<!-- @format -->

<template>
	<div class="p-6 container-medium m-auto mgs-centered-box">
		<img class="mb-10" alt="MGS logo" src="../assets/mgs.svg">
		<base-form class="w-full" ref="form" :form-data="form" @submitted="register"></base-form>
		<p>
			Already have an account? Please
			<router-link to="/login">Login</router-link>
		</p>
	</div>
</template>

<script>
/** @format */

export default {
	name: 'RegisterUser',
	methods: {
		register(payload) {
			this.$store
				.dispatch('user/register', payload)
				.then(() => {
					this.$router.push({name: 'Dashboard'});
				}).finally(() => {
					this.$refs.form.submitting = false;
				});
		}
	},
	data() {
		return {
			form: [
				{
					name: 'name',
					label: 'Name',
					component: 'base-input',
				},
				{
					name: 'handicap',
					label: 'Handicap',
					component: 'base-input',
				},
				{
					name: 'email',
					label: 'Email',
					component: 'base-email'
				},
				{
					name: 'password',
					label: 'Password',
					component: 'base-password',
				},
				{
					name: 'password_confirmation',
					label: 'Password Confirm',
					component: 'base-password'
				},
			]
		};
	}
};
</script>
